module.exports = __webpack_public_path__ + "static/media/1.8da74d91.jpg";